import { AlertCircle } from 'lucide-react';
import type * as React from 'react';
import { cn } from '../../lib/cn.ts';

export interface ErrorStateProps {
  title?: string;
  description?: string;
  action?: React.ReactNode;
  className?: string;
  'data-testid'?: string;
}

function ErrorState({
  title = 'Something went wrong',
  description = 'An error occurred. Please try again.',
  action,
  className,
  'data-testid': testId,
}: ErrorStateProps) {
  return (
    <div
      data-testid={testId ?? 'error-state'}
      className={cn(
        'flex flex-col items-center justify-center gap-4',
        'py-16 px-6 text-center',
        className,
      )}
    >
      <div aria-hidden="true" className="text-[var(--color-alert)]">
        <AlertCircle size={36} strokeWidth={1.3} />
      </div>
      <div className="flex flex-col gap-1.5 max-w-sm">
        <h3 className="font-[var(--font-display)] text-base font-medium text-[var(--color-charcoal)] tracking-tight">
          {title}
        </h3>
        {description && (
          <p className="text-sm text-[var(--color-stone-mid)] leading-relaxed">{description}</p>
        )}
      </div>
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}

export { ErrorState };
